import actions from './actions';

const initState = {
    data: [],
    selected: []
};

export default function PicklistReducer(state = initState, action) {
    switch (action.type) {
        case actions.Picklist_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        default:
            return state;
    }
}
